/**
 * @author xiaohuangmaoth
 * @description 线下培训及认证情况统计
 * @Date 2021/03/02
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool } from "@/tool";
import { templateConfig, reduxTemplateCofig } from "./config";
import column from './column';

const { WizContainer, WizReduxTemplate } = framework_tool;
const { WizBrowserExport } = component_tool

class OfflineTrainingAndCertificationStatistics extends WizContainer {
  componentName = "OfflineTrainingAndCertificationStatistics";

  handleFile(nextProps, nextState, key) {
    const res = nextProps[key]
    const { success, data = [], msg } = res

    if (success) {
      const rows = data.map(val => ({
        ...val,
        accountState: val.accountState ? '激活' :'禁用',
        attendanceState: val.attendanceState!=null && val.attendanceState===1 ? '请假' : val.attendanceState!=null && val.attendanceState===2 ?
          '全勤':val.attendanceState!=null && val.attendanceState===3 ? '缺勤' : '未输入',
        jobState: val.jobState!=null && val.jobState===1 ? '在职' :val.jobState!=null && val.jobState===0 ? '离职' :'',
        pass: val.pass ? '通过' :'未通过',
      }))

      const title = '培训班级及认证情况统计'

      WizBrowserExport({
        title,
        sheetName: title,
        columns: column.filter((_, index) => index),
        rows,
        filename: title + '.xlsx',
      })
      return true

    } else {
      wizNotice.error(msg)
      return false;
    }

  }

  _render() {
    const _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig.call(this),
      apiDataFormat: {
        export: this.handleFile
      },
    });

    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

export default connect(() => ({}))(OfflineTrainingAndCertificationStatistics);
